(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('tezly-countdown')) {
    customElements.define('tezly-countdown', class extends HTMLElement {
      connectedCallback() {
        this.endTime = Date.parse(this.dataset.end);
        if (Number.isNaN(this.endTime)) {
          this.hidden = true;
          return;
        }

        this.parts = {
          days: this.querySelector('[data-days]'),
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]')
        };

        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      update() {
        const now = Date.now();
        const day = 24 * 60 * 60 * 1000;

        if (this.endTime <= now) {
          const elapsedDays = Math.floor((now - this.endTime) / day) + 1;
          this.endTime += elapsedDays * day;
          this.classList.remove('is-expired');
          this.removeAttribute('aria-label');
        }

        const remaining = this.endTime - now;
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor(totalSeconds % 86400 / 3600);
        const minutes = Math.floor(totalSeconds % 3600 / 60);
        const seconds = totalSeconds % 60;

        this.setPart(this.parts.days, String(days).padStart(2, '0'));
        this.setPart(this.parts.hours, String(hours).padStart(2, '0'));
        this.setPart(this.parts.minutes, String(minutes).padStart(2, '0'));
        this.setPart(this.parts.seconds, String(seconds).padStart(2, '0'));

      }

      setPart(part, value) {
        if (part.textContent === value) return;
        const animate = part.textContent && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        part.textContent = value;
        if (!animate) return;
        part.classList.remove('is-flipping');
        void part.offsetWidth;
        part.classList.add('is-flipping');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('tz-projector-mobile-title')) {
    customElements.define('tz-projector-mobile-title', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => {
          this.mediaQuery = window.matchMedia('(max-width: 699px)');
          this.product = this.closest('.product--projector');
          this.titleBlock = this.product?.querySelector('.product-info [data-block-type="title"]');

          if (!this.titleBlock) {
            return;
          }

          this.originalParent = this.titleBlock.parentElement;
          this.originalNextSibling = this.titleBlock.nextElementSibling;
          this.updatePosition = () => {
            if (this.mediaQuery.matches) {
              if (this.titleBlock.parentElement !== this) {
                this.append(this.titleBlock);
              }
            } else if (this.titleBlock.parentElement === this) {
              this.originalParent.insertBefore(this.titleBlock, this.originalNextSibling);
            }
          };

          this.mediaQuery.addEventListener('change', this.updatePosition);
          this.updatePosition();
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.mediaQuery?.removeEventListener('change', this.updatePosition);
      }
    });
  }

  const syncReviewJumps = (root = document) => {
    const reviews = document.querySelector('[data-tzp-reviews]');
    const count = Number(reviews?.dataset.tzpReviewCount || 0);
    if (!reviews || count < 1) return;
    root.querySelectorAll('[data-tz-review-jump]').forEach((jump) => {
      const score = Number(reviews.dataset.tzpReviewAverage || 5);
      const scoreNode = jump.querySelector('[data-tz-review-score]');
      const countNode = jump.querySelector('[data-tz-review-count]');
      if (scoreNode) scoreNode.textContent = score.toFixed(1);
      if (countNode) countNode.textContent = `(${count})`;
      jump.hidden = false;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncReviewJumps(), { once: true });
  } else {
    syncReviewJumps();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tezly-premium-before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-tzp-compare]').forEach((compare) => {
        if (compare.dataset.ready === 'true') return;
        compare.dataset.ready = 'true';
        const range = compare.querySelector('[data-tzp-compare-range]');
        const after = compare.querySelector('[data-tzp-compare-after]');
        const line = compare.querySelector('[data-tzp-compare-line]');
        range?.addEventListener('input', () => {
          const value = `${range.value}%`;
          after.style.clipPath = `inset(0 calc(100% - ${value}) 0 0)`;
          line.style.left = value;
        });
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tezly-premium-benefits"] && !Shopify.designMode) return;
  try {
    
  const tzpBenefitInstances = new WeakMap();

  const initTzpBenefits = (scope = document) => {
    scope.querySelectorAll('[data-tzp-benefits]').forEach((section) => {
      if (tzpBenefitInstances.has(section)) return;

      const track = section.querySelector('[data-tzp-benefits-track]');
      const items = Array.from(section.querySelectorAll('[data-tzp-benefit]'));
      const mobileQuery = window.matchMedia('(max-width: 849px)');
      const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Math.max(2000, Number(section.dataset.interval) || 2000);
      let timer;
      let resumeTimer;

      if (!track || items.length < 2 || section.dataset.autoplay !== 'true') return;

      const itemPosition = (item) => item.offsetLeft - items[0].offsetLeft;

      const currentIndex = () => {
        return items.reduce((closest, item, index) => {
          const distance = Math.abs(itemPosition(item) - track.scrollLeft);
          return distance < closest.distance ? { index, distance } : closest;
        }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
      };

      const stop = () => {
        window.clearInterval(timer);
        window.clearTimeout(resumeTimer);
      };

      const advance = () => {
        if (!mobileQuery.matches || track.scrollWidth <= track.clientWidth + 2) return;
        const nextIndex = (currentIndex() + 1) % items.length;
        track.scrollTo({ left: itemPosition(items[nextIndex]), behavior: 'smooth' });
      };

      const start = () => {
        stop();
        if (!mobileQuery.matches || motionQuery.matches || document.hidden) return;
        timer = window.setInterval(advance, interval);
      };

      const resume = () => {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(start, 700);
      };

      track.addEventListener('pointerdown', stop);
      track.addEventListener('pointerup', resume);
      track.addEventListener('pointercancel', resume);
      track.addEventListener('focusin', stop);
      track.addEventListener('focusout', resume);
      mobileQuery.addEventListener('change', start);
      motionQuery.addEventListener('change', start);
      document.addEventListener('visibilitychange', start);

      tzpBenefitInstances.set(section, {
        destroy: () => {
          stop();
          track.removeEventListener('pointerdown', stop);
          track.removeEventListener('pointerup', resume);
          track.removeEventListener('pointercancel', resume);
          track.removeEventListener('focusin', stop);
          track.removeEventListener('focusout', resume);
          mobileQuery.removeEventListener('change', start);
          motionQuery.removeEventListener('change', start);
          document.removeEventListener('visibilitychange', start);
        }
      });

      start();
    });
  };

  initTzpBenefits();

  document.addEventListener('shopify:section:load', (event) => initTzpBenefits(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-tzp-benefits]');
    const instance = section && tzpBenefitInstances.get(section);
    if (instance) instance.destroy();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tezly-premium-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, format) => {
      const value = (Number(cents || 0) / 100).toFixed(2);
      const amountToken = '{' + '{amount}' + '}';
      const noDecimalsToken = '{' + '{amount_no_decimals}' + '}';
      return String(format || `$${amountToken}`)
        .replace(amountToken, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(noDecimalsToken, Math.round(Number(value)).toLocaleString());
    };

    const init = (section) => {
      if (section.dataset.tzpReady === 'true') return;
      section.dataset.tzpReady = 'true';

      const track = section.querySelector('[data-tzp-media-track]');
      const thumbs = [...section.querySelectorAll('[data-tzp-thumb]')];
      const select = section.querySelector('[data-tzp-variant-select]');
      const price = section.querySelector('[data-tzp-price]');
      const compare = section.querySelector('[data-tzp-compare]');
      const discount = section.querySelector('[data-tzp-discount]');
      const addButton = section.querySelector('[data-tzp-add-button]');
      const addLabel = section.querySelector('[data-tzp-add-label]');
      const stockLabel = section.querySelector('[data-tzp-stock-label]');
      const dataNode = section.querySelector('[data-tzp-product-data]');
      const data = dataNode ? JSON.parse(dataNode.textContent) : {};
      const stickyOrder = section.querySelector('[data-tzp-sticky-order]');
      const stickyButton = section.querySelector('[data-tzp-sticky-button]');

      const activateThumb = (index) => {
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', String(active));
        });
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.mediaIndex || 0);
          const target = track?.querySelector(`[data-media-index="${index}"]`);
          target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          activateThumb(index);
        });
      });

      if (track && thumbs.length) {
        let frame;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
            activateThumb(Math.min(index, thumbs.length - 1));
          });
        }, { passive: true });
      }

      const updateVariant = () => {
        if (!select) return;
        const option = select.selectedOptions[0];
        const variantPrice = Number(option.dataset.price || 0);
        const comparePrice = Number(option.dataset.compare || 0);
        const available = option.dataset.available === 'true';
        const mediaId = option.dataset.mediaId;

        price.textContent = formatMoney(variantPrice, data.moneyFormat);
        if (comparePrice > variantPrice) {
          compare.textContent = formatMoney(comparePrice, data.moneyFormat);
          compare.classList.remove('is-hidden');
          discount.textContent = `${Math.round(((comparePrice - variantPrice) * 100) / comparePrice)}%`;
          discount.classList.remove('is-hidden');
        } else {
          compare.classList.add('is-hidden');
          discount.classList.add('is-hidden');
        }

        addButton.disabled = !available;
        addLabel.textContent = available ? data.addLabel : data.soldOutLabel;
        if (stockLabel) stockLabel.textContent = available ? data.inStockLabel : data.soldOutLabel;

        if (mediaId && track) {
          const target = track.querySelector(`[data-media-id="${mediaId}"]`);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            activateThumb(Number(target.dataset.mediaIndex || 0));
          }
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      };

      select?.addEventListener('change', updateVariant);

      const quantity = section.querySelector('[data-tzp-quantity] input');
      section.querySelector('[data-tzp-quantity-minus]')?.addEventListener('click', () => {
        if (!quantity) return;
        quantity.stepDown();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      section.querySelector('[data-tzp-quantity-plus]')?.addEventListener('click', () => {
        if (!quantity) return;
        quantity.stepUp();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const goToCheckout = () => {
        const checkout = document.querySelector('[data-tzp-inline-checkout]');
        if (!checkout) return false;

        const activeVariant = select?.value || section.querySelector('[data-tzp-variant-id]')?.value;
        const checkoutVariant = checkout.querySelector('[name="variant"]');
        if (activeVariant && checkoutVariant) {
          checkoutVariant.value = activeVariant;
          checkoutVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const requestedQuantity = Number(quantity?.value || 1);
        const matchingTier = [...checkout.querySelectorAll('[data-qty]')]
          .find((tier) => Number(tier.dataset.qty) === requestedQuantity)
          ?.querySelector('input[type="radio"]');
        if (matchingTier) {
          matchingTier.checked = true;
          matchingTier.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        checkout.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        return true;
      };

      addButton?.addEventListener('click', (event) => {
        event.preventDefault();
        goToCheckout();
      });

      stickyButton?.addEventListener('click', () => goToCheckout());

      if (stickyOrder && addButton && 'IntersectionObserver' in window) {
        let mainButtonVisible = true;
        let checkoutVisible = false;
        const updateStickyOrder = () => {
          const available = !addButton.disabled;
          const shouldShow = available && !mainButtonVisible && !checkoutVisible;
          stickyOrder.classList.toggle('is-visible', shouldShow);
          stickyOrder.setAttribute('aria-hidden', String(!shouldShow));
          stickyButton.tabIndex = shouldShow ? 0 : -1;
        };
        new IntersectionObserver((entries) => {
          mainButtonVisible = entries[0]?.isIntersecting ?? true;
          updateStickyOrder();
        }, { threshold: 0.25 }).observe(addButton);

        const checkout = document.querySelector('[data-tzp-inline-checkout]');
        if (checkout) {
          new IntersectionObserver((entries) => {
            checkoutVisible = entries[0]?.isIntersecting ?? false;
            updateStickyOrder();
          }, { threshold: 0.1 }).observe(checkout);
        }
      }
    };

    document.querySelectorAll('[data-tzp-product]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-tzp-product]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tezly-premium-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const submitReview = async (event) => {
      const reviewForm = event.target;
      if (!(reviewForm instanceof HTMLFormElement) || !reviewForm.matches('[data-tzp-review-form]')) return;
      const section = reviewForm.closest('[data-tzp-reviews]');
      const reviewEndpoint = section?.dataset.tzpReviewEndpoint;
      if (!section || !reviewEndpoint) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const submitFeedback = section.querySelector('[data-tzp-review-submit-feedback]');
      const submitButton = reviewForm.querySelector('[type="submit"]');
      const photoInput = reviewForm.querySelector('[data-tzp-review-photo]');
      const mediaFile = photoInput?.files?.[0];
      const allowedMediaTypes = ['image/jpeg', 'image/png', 'image/webp', 'video/mp4', 'video/webm', 'video/quicktime'];
      if (mediaFile && (!allowedMediaTypes.includes(mediaFile.type) || mediaFile.size > 25 * 1024 * 1024)) {
        submitFeedback.textContent = 'Choose a JPG, PNG, WebP, MP4, WebM or MOV file up to 25 MB.';
        submitFeedback.hidden = false;
        submitFeedback.focus();
        return;
      }
      const formData = new FormData(reviewForm);
      const submitLabel = submitButton.textContent;
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.textContent = 'Sending review…';
      submitFeedback.hidden = true;
      try {
        const payload = new FormData();
        payload.set('name', String(formData.get('contact[name]') || ''));
        payload.set('email', String(formData.get('contact[email]') || ''));
        payload.set('rating', String(formData.get('contact[rating]') || ''));
        payload.set('review', String(formData.get('contact[body]') || ''));
        payload.set('product_name', section.dataset.tzpProductName || '');
        payload.set('product_handle', section.dataset.tzpProductHandle || '');
        payload.set('page_url', window.location.href);
        payload.set('website', '');
        if (mediaFile) payload.set('media', mediaFile, mediaFile.name);
        const response = await fetch(reviewEndpoint, { method: 'POST', headers: { 'Accept': 'application/json' }, body: payload });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || result?.ok !== true) throw new Error(result?.error || 'Review submission failed');
        reviewForm.reset();
        submitFeedback.textContent = 'Thanks for your review — it’s pending approval.';
        submitFeedback.hidden = false;
        submitFeedback.focus();
      } catch (error) {
        submitFeedback.textContent = error?.message || 'We could not submit your review. Please try again.';
        submitFeedback.hidden = false;
        submitFeedback.focus();
      } finally {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        submitButton.textContent = submitLabel;
      }
    };
    document.addEventListener('submit', submitReview, true);

    const init = (root) => {
      root.querySelectorAll('[data-tzp-reviews]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';
        const cards = [...section.querySelectorAll('[data-tzp-review-card]')];
        const filter = section.querySelector('[data-tzp-review-filter]');
        const loadMore = section.querySelector('[data-tzp-review-load-more]');
        let activeFilter = 'all';
        let isExpanded = false;
        const updateCards = () => {
          let visibleCount = 0;
          cards.forEach((card) => {
            const matches = activeFilter === 'all' || Number(card.dataset.rating) >= Number(activeFilter);
            if (matches) visibleCount += 1;
            card.hidden = !matches || (!isExpanded && visibleCount > 4);
          });
          if (loadMore) loadMore.hidden = isExpanded || visibleCount <= 4;
        };
        section.querySelectorAll('[data-tzp-filter-value]').forEach((button) => {
          button.addEventListener('click', () => {
            activeFilter = button.dataset.tzpFilterValue;
            isExpanded = false;
            section.querySelectorAll('[data-tzp-filter-value]').forEach((item) => item.classList.toggle('is-active', item === button));
            updateCards();
            if (filter) filter.open = false;
          });
        });
        loadMore?.addEventListener('click', () => {
          isExpanded = true;
          updateCards();
        });
        updateCards();

        const dialog = section.querySelector('[data-tzp-review-dialog]');
        section.querySelector('[data-tzp-review-open]')?.addEventListener('click', () => dialog?.showModal());
        section.querySelector('[data-tzp-review-close]')?.addEventListener('click', () => dialog?.close());
        dialog?.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        if (dialog?.querySelector('[data-tzp-review-feedback]')) dialog.showModal();

        const reviewForm = dialog?.querySelector('form');
        const reviewEndpoint = section.dataset.tzpReviewEndpoint;
        const submitFeedback = section.querySelector('[data-tzp-review-submit-feedback]');
        reviewForm?.addEventListener('submit', async (event) => {
          if (!reviewEndpoint) return;
          event.preventDefault();
          const photoInput = reviewForm.querySelector('[data-tzp-review-photo]');
          const mediaFile = photoInput?.files?.[0];
          const allowedMediaTypes = ['image/jpeg', 'image/png', 'image/webp', 'video/mp4', 'video/webm', 'video/quicktime'];
          if (mediaFile && (!allowedMediaTypes.includes(mediaFile.type) || mediaFile.size > 25 * 1024 * 1024)) {
            submitFeedback.textContent = 'Choose a JPG, PNG, WebP, MP4, WebM or MOV file up to 25 MB.';
            submitFeedback.hidden = false;
            submitFeedback.focus();
            return;
          }
          const submitButton = reviewForm.querySelector('[type="submit"]');
          const formData = new FormData(reviewForm);
          submitButton.disabled = true;
          submitFeedback.hidden = true;
          try {
            const payload = new FormData();
            payload.set('name', String(formData.get('contact[name]') || ''));
            payload.set('email', String(formData.get('contact[email]') || ''));
            payload.set('rating', String(formData.get('contact[rating]') || ''));
            payload.set('review', String(formData.get('contact[body]') || ''));
            payload.set('product_name', section.dataset.tzpProductName || '');
            payload.set('product_handle', section.dataset.tzpProductHandle || '');
            payload.set('page_url', window.location.href);
            payload.set('website', '');
            if (mediaFile) payload.set('media', mediaFile, mediaFile.name);
            const response = await fetch(reviewEndpoint, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: payload,
            });
            const result = await response.json().catch(() => ({}));
            if (!response.ok || result?.ok !== true) throw new Error(result?.error || 'Review submission failed');
            reviewForm.reset();
            submitFeedback.textContent = section.dataset.tzpReviewSuccess;
            submitFeedback.hidden = false;
            submitFeedback.focus();
          } catch (error) {
            submitFeedback.textContent = error?.message || 'We could not submit your review. Please try again.';
            submitFeedback.hidden = false;
            submitFeedback.focus();
          } finally {
            submitButton.disabled = false;
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tezly-premium-video-reel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-tzv-reel]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const cards = Array.from(section.querySelectorAll('[data-tzv-card]'));
        const videos = cards.map((card) => card.querySelector('video')).filter(Boolean);

        cards.forEach((card) => {
          const video = card.querySelector('video');
          const play = card.querySelector('[data-tzv-play]');
          if (!video || !play) return;

          play.addEventListener('click', () => {
            card.classList.remove('is-unavailable');
            videos.forEach((otherVideo) => {
              if (otherVideo !== video) otherVideo.pause();
            });
            video.controls = true;
            video.load();
            video.play().then(() => card.classList.add('is-playing')).catch(() => {
              card.classList.add('is-unavailable');
              video.controls = false;
            });
          });

          video.addEventListener('play', () => card.classList.add('is-playing'));
          video.addEventListener('ended', () => {
            card.classList.remove('is-playing');
            video.controls = false;
            video.currentTime = 0;
          });
          video.addEventListener('error', () => {
            card.classList.add('is-unavailable');
            video.controls = false;
          });
        });

        const observer = new IntersectionObserver((entries) => {
          if (entries[0]?.isIntersecting) return;
          videos.forEach((video) => video.pause());
        }, { threshold: 0.05 });
        observer.observe(section);
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tezly-projector-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tz-projector-comparison')) {
    customElements.define('tz-projector-comparison', class extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('input[type="range"]');

        if (!this.range) {
          return;
        }

        this.updatePosition = () => {
          this.style.setProperty('--tz-compare-position', `${this.range.value}%`);
        };

        this.range.addEventListener('input', this.updatePosition);
        this.updatePosition();
      }

      disconnectedCallback() {
        this.range?.removeEventListener('input', this.updatePosition);
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tezly-screen-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tezly-comparison')) {
  customElements.define('tezly-comparison', class extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      const update = () => this.style.setProperty('--comparison-position', `${range.value}%`);
      range.addEventListener('input', update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tezly-thank-you"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-tz-thanks]');
    if (!root) return;
    const params = new URLSearchParams(window.location.search);
    const orderName = params.get('order');
    const orderElement = root.querySelector('[data-tz-thanks-order]');
    if (orderName && orderElement) {
      orderElement.textContent = `Order ${orderName}`;
      orderElement.hidden = false;
    }
    let summary = null;
    try { summary = JSON.parse(sessionStorage.getItem('tz_order_summary') || 'null'); } catch (error) { summary = null; }
    if (!summary) return;
    const title = root.querySelector('[data-tz-thanks-title]');
    if (title && summary.firstName) title.textContent = `${title.dataset.heading}, ${summary.firstName}!`;
    const product = root.querySelector('[data-tz-thanks-product]');
    const quantity = root.querySelector('[data-tz-thanks-quantity]');
    const total = root.querySelector('[data-tz-thanks-total]');
    if (product) product.textContent = summary.product || '';
    if (quantity) quantity.textContent = `Quantity: ${summary.quantity || 1}`;
    if (total) total.textContent = summary.total || '';
    const summaryCard = root.querySelector('[data-tz-thanks-summary]');
    if (summaryCard) summaryCard.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();
})();
